import { CDN_ASSETS_PATH } from './cdn';

export enum BundleAncillaryTypeEnum {
  BAGGAGE = 'baggage',
  MEALS = 'meals',
  SEAT = 'seat',
  WHEELCHAIR = 'wheelchair',
  INSURANCE = 'insurance',
  FASTPASS = 'fastPass',
  BUNDLE = 'bundle',
  OTHER = 'other',
}

export enum FlightKeyEnum {
  DEPART_FLIGHT = 'departFlight',
  RETURN_FLIGHT = 'returnFlight',
}

export const FLATBED_BUNDLE_NAME = 'Premium Flatbed';

export const WHEELCHAIR_READ_MORE_URL =
  'https://support.airasia.com/s/article/Prebook-special-needs-assistance-en?language=zh_CN';
export const WHEELCHAIR_UNAVAILABLE_LOGO_URL = `${CDN_ASSETS_PATH}/images/No_wheelchair_available.svg`;
export const WHEELCHAIR_LOGO_URL = `${CDN_ASSETS_PATH}/images/Special_assistance.svg`;

export const INSURANCE_MAIN_WIDGET_IMAGE = `${CDN_ASSETS_PATH}/images/insurance.svg`;

export const paxTypes: { [key: string]: AACheckout.PaxType } = {
  infant: 'infant',
  child: 'child',
  adult: 'adult',
  ypta: 'ypta',
};

export const mapGuestTypes = {
  infant: 'Infant',
  child: 'Child',
  adult: 'Adult',
};

export const CABIN_CLASS = {
  M: 'ECONOMY',
  W: 'PREMIUM_ECONOMY',
  C: 'BUSINESS',
  F: 'FIRST',
};
